<template>
  <a-spin :spinning="loading" class="demo__padding--15 demo__padding-mobile--0">
    <div class="demo__flex demo__top">
      <i
        class="fa-solid demo__font--20 demo__color--brandPrimary"
        v-bind:class="[subsInfo.icon]"
      ></i>
      <div
        class="demo__font--20 demo__weight--600 demo__margin-left--12 demo__font-mobile--16 demo__color--black"
      >
        {{ subsInfo.title }}
      </div>
    </div>
    <component :is="subsInfo.component" :subsInfo="subsInfo" />
  </a-spin>
</template>

<script>
import AnyText from "./components/AnyText";
import Unsubscribe from "./components/Unsubscribe";
import LetsSubscribe from "./components/LetsSubscribe";

export default {
  components: {
    AnyText,
    Unsubscribe,
    LetsSubscribe,
  },
  data() {
    return {
      loading: false,
    };
  },
  props: {
    subsInfo: {
      type: Object,
      required: true,
    },
  },
  beforeDestroy() {
    this.$root.$on(
      "updateSubsModalInfoLoading",
      this.updateSubsModalInfoLoading
    );
  },
  created() {
    this.$root.$on(
      "updateSubsModalInfoLoading",
      this.updateSubsModalInfoLoading
    );
    this.$accessModule("subsinfo", this);
  },
  methods: {
    updateSubsModalInfoLoading(loading) {
      this.loading = loading;
    },
  },
};
</script>
